const actions = {
  STORE_MARKETING_EXPENSE_BEGIN: 'STORE_MARKETING_EXPENSE_BEGIN',
  STORE_MARKETING_EXPENSE_SUCCESS: 'STORE_MARKETING_EXPENSE_SUCCESS',
  STORE_MARKETING_EXPENSE_ERR: 'STORE_MARKETING_EXPENSE_ERR',
  STORE_MARKETING_IMAGES_GALLERY_BEGIN: 'STORE_MARKETING_IMAGES_GALLERY_BEGIN',
  STORE_MARKETING_IMAGES_GALLERY_SUCCESS: 'STORE_MARKETING_IMAGES_GALLERY_SUCCESS',
  STORE_MARKETING_IMAGES_GALLERY_ERR: 'STORE_MARKETING_IMAGES_GALLERY_ERR',

  getStoreMarketingExpenseBegin: (month) => ({ type: actions.STORE_MARKETING_EXPENSE_BEGIN, month }),
  getStoreMarketingExpenseSuccess: (data, month, overviewYear) => ({
    type: actions.STORE_MARKETING_EXPENSE_SUCCESS, data, month, overviewYear,
  }),
  getStoreMarketingExpenseErr: (err, month) => ({ type: actions.STORE_MARKETING_EXPENSE_ERR, err, month }),
  getStoreMarketingImagesGalleryBegin: (month) => ({
    type: actions.STORE_MARKETING_IMAGES_GALLERY_BEGIN, month,
  }),
  getStoreMarketingImagesGallerySuccess: (data, month) => ({
    type: actions.STORE_MARKETING_IMAGES_GALLERY_SUCCESS, data, month,
  }),
  getStoreMarketingImagesGalleryErr: (err, month) => ({
    type: actions.STORE_MARKETING_IMAGES_GALLERY_ERR, err, month,
  }),
};

export default actions;
